<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
    import dayjs from 'dayjs';
    import EchoButton from '../../EchoButton.vue';
    import UserCell from './UserCell.vue';
    import CoachingCategoryLabel from '../CoachingCategoryLabel.vue';
    import { ICoachingFormTableItem } from '@/js/services/api/coachingForm/types';
    import { CoachingFormTableColumn } from '@/js/stores/coaching-form-table';
    import { ChevronRightIcon } from '@lucide/vue';

    defineProps<{
        column: CoachingFormTableColumn['field'];
        data: ICoachingFormTableItem;
    }>();

    defineEmits<{
        (e: 'show-version-history', id: string): void;
    }>();
</script>
<template>
    <div class="h-10 flex items-center" :class="{ 'opacity-50': !data.isActive }">
        <template v-if="column === 'title'">
            <div>
                <p class="text-body">
                    {{ data.title }}
                    <template v-if="!data.isActive">({{ __('inactive') }})</template>
                </p>
            </div>
        </template>
        <template v-else-if="column === 'useAi' && data.useAi !== undefined">
            <CoachingCategoryLabel :ai="data.useAi">
                <p>{{ data.useAi ? __('ai') : __('manual') }}</p>
            </CoachingCategoryLabel>
        </template>
        <template v-else-if="column === 'createdAt'">
            <p v-if="data.createdAt" class="text-body">
                {{ dayjs(data.createdAt).format('YYYY-MM-DD') }}
            </p>
        </template>
        <template v-else-if="column === 'createdBy'">
            <UserCell v-if="data.createdBy" :label="data.createdBy" />
        </template>
        <template v-else-if="column === 'updatedBy'">
            <UserCell v-if="data.updatedBy" :label="data.updatedBy" />
        </template>
        <template v-else-if="column === 'actions'">
            <EchoButton
                :aria-label="__('open') + ' ' + data.title"
                size="large"
                variant="tertiary"
                :route="'/settings/manage-forms/' + data.id"
            >
                {{ __('open') }}
                <template #icon-right><ChevronRightIcon /></template>
            </EchoButton>
        </template>
    </div>
</template>
